export const MAPI_API_TYPE = "MAPI";
export const OAPI_API_TYPE = "OAPI";
export const PPI_PAYMENT_TYPE_MEAL = "Meal";
export const PPI_PAYMENT_TYPE_MEAL_EQUIV = "Meal Equivalency";

export const PPI_PAYMENT_TYPES = {
  CAMPUS: 11
};

export const PPI_SUBPAYMENT_TYPES = {
  CBORD: 16,
  ATRIUM: 40,
  TROVE: 50
};

export const CAMPUS_SUBPAYMENT_TYPES = [PPI_SUBPAYMENT_TYPES.CBORD, PPI_SUBPAYMENT_TYPES.ATRIUM, PPI_SUBPAYMENT_TYPES.TROVE];

// For saved campus cards, we are only saving the subpayment type
// so we need a map to look up the payment type and display name
export const CAMPUS_ACCOUNT_MAP = {
  16: { display: "CBORD", paymentType: 11 },
  40: { display: "Atrium", paymentType: 11 },
  50: { display: "Trove", paymentType: 11 }
};

export const CAMPUS_PAYMENT_TYPES = [
  `${PPI_PAYMENT_TYPES.CAMPUS}|${PPI_SUBPAYMENT_TYPES.CBORD}`,
  `${PPI_PAYMENT_TYPES.CAMPUS}|${PPI_SUBPAYMENT_TYPES.ATRIUM}`,
  `${PPI_PAYMENT_TYPES.CAMPUS}|${PPI_SUBPAYMENT_TYPES.TROVE}`
];

export const ORDER_SOURCE_HEADER = "x-order-source";
export const ORDER_SOURCE_HEADER_VALUE_OAPI = "interact_web_oapi";
export const ORDER_SOURCE_HEADER_VALUE_MAPI = "interact_web_mapi";


export const TOKENIZED_PAYMENT_TYPE = 22